/**
 * Pre-Auth HTTP contract, shared by emr-api (PreAuthManager/Controller) and
 * emr-web (APIService + the Pre-Auth modal).
 */

export interface DrugCandidate {
  din: string;
  drugName?: string;
  strength?: string;
}

export interface PreAuthCreateDto {
  customerId: string;
  /** When omitted, the server returns candidate drugs to confirm/choose. */
  din?: string;
}

/**
 * Response of POST /pre-auth/create (confirm-first):
 * - no `din` sent → `{ drugs }` — candidates to confirm/choose (may be empty); nothing created in OkRx yet.
 * - `din` sent    → `{ url }`   — the OkRx form was created; open this URL.
 */
export type PreAuthResult = { url: string } | { drugs: DrugCandidate[] };
